import { useSuspenseQuery } from '@tanstack/react-query';

import { CheckoutView } from '@/components/cart/checkout-view';
import { meQuery } from '@/queries';

export default function CheckoutPage() {
  // Whether Stripe has keys is a server fact. It used to be read straight off
  // process.env in a server component; now it rides down with the session, so
  // the browser gets the answer and never the environment.
  const { user, stripeConfigured } = useSuspenseQuery(meQuery).data;

  return (
    <div className="mx-auto max-w-[1180px] px-[30px] py-12">
      <h1 className="mb-8 text-[32px] font-extrabold tracking-[-0.03em] sm:text-[38px]">
        Checkout
      </h1>
      <CheckoutView
        signedInEmail={user?.email ?? null}
        stripeConfigured={stripeConfigured}
      />
    </div>
  );
}
